var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmergencyContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5261 3.58L10.8594 2.42667C10.7702 2.27372 10.6243 2.16207 10.4534 2.1159C10.2824 2.06974 10.1002 2.09276 9.94609 2.18L7.33276 3.69333V0.666667C7.33276 0.3 7.03276 0 6.66609 0H5.33276C4.96609 0 4.66609 0.3 4.66609 0.666667V3.69333L2.04609 2.18C1.97084 2.13607 1.88766 2.10742 1.80131 2.09571C1.71497 2.084 1.62716 2.08945 1.54293 2.11174C1.45869 2.13404 1.37969 2.17275 1.31045 2.22565C1.2412 2.27854 1.18309 2.34459 1.13943 2.42L0.472758 3.57333C0.286092 3.89333 0.392759 4.30667 0.712759 4.48667L3.33276 6L0.712759 7.51333C0.392759 7.7 0.286092 8.10667 0.466092 8.42667L1.13276 9.58C1.31942 9.9 1.72609 10.0067 2.04609 9.82667L4.66609 8.30667V11.3333C4.66609 11.7 4.96609 12 5.33276 12H6.66609C7.03276 12 7.33276 11.7 7.33276 11.3333V8.30667L9.95276 9.82C10.2728 10.0067 10.6794 9.89333 10.8661 9.57333L11.5328 8.42C11.7194 8.1 11.6061 7.69333 11.2861 7.50667L8.66609 6L11.2861 4.48667C11.6061 4.30667 11.7128 3.89333 11.5261 3.58Z",
    fill: "#725CE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyContactIcon);
export default __webpack_public_path__ + "static/media/emergencyContactIcon.e129817444afcb35f0dc6d6ecdf2f222.svg";
export { ForwardRef as ReactComponent };